import styled from "styled-components";

export const Styles = styled.div`
  &.attachment-table:has(.ant-upload-list-text-container) {
    position: relative;
    .item-list-file {
      min-height: 44px;
      .actions_file {
        transform: translateY(7px);
      }
    }
    .icon_attachment {
      font-size: 14px !important;
      width: 20px !important;
      height: 10px !important;
    }
    .ant-input {
      height: 12px;
      font-size: 1px;
      padding: 0;
    }
    .ant-upload.ant-upload-drag {
      width: 55px;
      position: absolute;
      right: 0;
      height: 15px;
      top: calc(50% - 17px);
    }
  }

  &.disabled:has(.ant-upload-list-text-container) {
    .item-list-file {
      min-height: 0px;
      justify-content: center !important;
    }
    .ant-upload-disabled {
      display: none;
    }
    .actions_file {
      display: none !important;
    }
  }

  &.attachment.disabled:has(.ant-upload-list-text-container) {
    .item-list-file-content {
      max-width: 100%;
    }
  }

  .item-list-file-content {
    display: flex;
    align-items: center;
    max-width: calc(100% - 55px);
    position: relative;
  }
`;

export const StyleLabelRequired = styled.span`
  margin-right: 4px;
  color: #ff4d4f;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
`;
